import { render } from "./UserListLinks.vue?vue&type=template&id=94a235fc"
import script from "./UserListLinks.vue?vue&type=script&lang=js"
export * from "./UserListLinks.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./UserListLinks.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/data/vstsagent02/user/3205/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__